import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// Only enable Sentry in production (client-side check via build-time env)
const environment = (process.env.NODE_ENV ?? "") as string;

function initSentry() {
  if (environment !== "production" && environment !== "staging") {
    return;
  }

  Sentry.init({
    dsn: "https://55ccfda0770808d40a2e445f7a5d3d3b@o975601.ingest.us.sentry.io/4508792844255232",
    tracesSampleRate: 0.01,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    replaysSessionSampleRate: 0.01,
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});

if (typeof window !== "undefined") {
  const browserWindow = window as Window & typeof globalThis;
  if (
    "requestIdleCallback" in browserWindow &&
    typeof browserWindow.requestIdleCallback === "function"
  ) {
    browserWindow.requestIdleCallback(() => {
      initSentry();
    });
  } else {
    globalThis.setTimeout(() => {
      initSentry();
    }, 0);
  }
}
